import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutArrivedAtShipper extends Layout {
    labelArrivedAtShipper: Label;
    labelLabel2: Label;
    sourceArrivedAtShipper: DataSource;
}
